import React, { useRef } from 'react';
import VariablePicker from './VariablePicker';

const InputWithVariablePicker = ({
  value,
  onChange,
  placeholder,
  className = "",
  type = "text",
  rows = 3,
  clientId = null,
  contactId = null,
  showVariablePicker = true,
  disabled = false,
  ...props
}) => {
  const inputRef = useRef(null);
  const textareaRef = useRef(null);

  const handleVariableSelect = (variable) => {
    const ref = type === 'textarea' ? textareaRef : inputRef;
    const input = ref.current;
    
    if (input) {
      const start = input.selectionStart;
      const end = input.selectionEnd;
      const text = value || '';
      
      // Insert variable at cursor position
      const newValue = text.substring(0, start) + variable + text.substring(end);
      
      // Update the value
      onChange({ target: { value: newValue } });
      
      // Set cursor position after the inserted variable
      setTimeout(() => {
        input.focus();
        const newCursorPos = start + variable.length;
        input.setSelectionRange(newCursorPos, newCursorPos);
      }, 0);
    } else {
      // Fallback: append to end
      onChange({ target: { value: (value || '') + variable } });
    }
  };

  const baseClassName = `
    w-full px-4 py-2 pr-10 border border-gray-300 rounded-lg 
    focus:ring-2 focus:ring-purple-500 focus:border-transparent
    disabled:bg-gray-100 disabled:cursor-not-allowed
    ${className}
  `.trim();

  return (
    <div className="relative">
      {type === 'textarea' ? (
        <textarea
          ref={textareaRef}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          className={baseClassName}
          rows={rows}
          disabled={disabled}
          {...props}
        />
      ) : (
        <input
          ref={inputRef}
          type={type}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          className={baseClassName}
          disabled={disabled}
          {...props}
        />
      )}
      
      {showVariablePicker && !disabled && (
        <div className="absolute right-2 top-1/2 transform -translate-y-1/2">
          <VariablePicker
            onVariableSelect={handleVariableSelect}
            clientId={clientId}
            contactId={contactId}
            buttonClassName="p-1 text-gray-400 hover:text-purple-600 transition-colors"
            showPreview={true}
          />
        </div>
      )}
    </div>
  );
};

export default InputWithVariablePicker;